import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { toRefs, inject } from 'vue';
import { useLogger } from 'vue-logger-plugin';
import { DeviceService } from '../../services/device.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleButton',
  props: {
    targetDiv: {
        type: String,
        default: ''
    },
    addedClass: {
        type: String,
        default: ''
    },
    disableDesktop: {
        type: Boolean,
        default: false
    },
    toggleDiv: {
        type: String,
        default: ''
    },
    toggleMessage: {
        type: String,
        default: ''
    }
},
  setup(__props) {

const props = __props;

// Use absloute path
const deviceService: DeviceService | undefined = inject('DeviceService');

// Incoming props


// get back slide card info
const { targetDiv, addedClass, disableDesktop, toggleDiv, toggleMessage } = toRefs(props);
const logger = useLogger();

// Initialize the affix functionality and other variables
const toggleClick = () => {
    logger.debug('clicked toggle for', targetDiv, disableDesktop, deviceService?.isDesktop());
    
    // for mobile do not expand menu
    if (disableDesktop.value && deviceService?.isDesktop()) {
        return;
    }

    const targetItem = document.getElementById(targetDiv.value);

    if (!targetItem) {
        return;
    }

    const toggleItem = document.getElementById(toggleDiv.value);

    if (addedClass.value?.length) {
        targetItem.classList.toggle(addedClass.value);
    } else {
        targetItem.classList.toggle('in');
    }

    if (targetItem.style.display == 'block') { 
        targetItem.style.display = 'none';

        // remove the toggle message if there was one
        if (toggleItem) {
            toggleItem.removeChild(toggleItem.lastElementChild);
        }
    } else{
        targetItem.style.display = 'block';
        
        // append any sort of toggle message if we had one
        if (toggleItem) {
            const node = document.createElement('span');
            node.innerText = toggleMessage.value;

            toggleItem.appendChild(node);
        }
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", { onClick: toggleClick }, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})